import { deepCopy, filterOptions } from "./utils";

import { CONFIG_NAME_GPIO } from './constants';
import { configGpio } from "./gpio";

/**
 * 重置引脚功能
 */
export function resetState(state, position) {
    //TODO: STM32 如果是USART的某个引脚重置，则整个IP Instance全部重置
    const pin = state.chip.pins[position - 1];
    const ip = state.chip.ips.find(i => i.name === pin.ip);

    if (ip) {
        pin.ip = '';
        pin.signal = '';

        const indexInIp = ip.pins.findIndex(p => p.position === position);

        if (indexInIp != -1) {
            ip.pins.splice(indexInIp, 1)
        }

        if (state.pinIndex === indexInIp) {
            state.pinIndex = -1;
        } else if (state.pinIndex > indexInIp) {
            state.pinIndex = state.pinIndex - 1;
        }
    }
}


export function changeSignal(state, { position, signal }) {

    const array = signal.split('_');
    const ipName = array[0];
    const modeName = array[1];

    let pin = state.chip.pins[position - 1];
    


    if (ipName === 'GPIO') {
        const gpioInstance = state.chip.ips.find(ip => ip.name === 'GPIO')

        pin.signal = signal;
        pin.ip = gpioInstance.name;

        const gpio = state.config[CONFIG_NAME_GPIO];
        const pinCopy = configGpio(state, pin, modeName);
        
        const index = gpioInstance.pins.findIndex(p => p.position === position);
        if (index === -1) {
            gpioInstance.pins.push(pinCopy);
            state.pinIndex = gpioInstance.pins.length - 1;
        } else {
            gpioInstance.pins.splice(index, 1, pinCopy);
            state.pinIndex = index;
        }
        
    } else if (ip.name === 'USART') {

    }
}